module.exports = __webpack_public_path__ + "static/media/stack.16d0d961.png";